import React from 'react'

import { InputAutoComplete } from 'components/form'

import { equipmentAutocomplete } from './actions'

interface ComponentProps {
  name: string
  label: string
  desktopSize?: number
  tabletSize?: number
  disabled?: boolean
  clientId?: string | null
  [x: string]: any
}

const Component: React.FC<ComponentProps> = ({ name, label, desktopSize, tabletSize, clientId, ...rest }) => {
  return (
    <InputAutoComplete
      name={name}
      label={label}
      searchData={equipmentAutocomplete}
      searchCustomData={{ clientId }}
      desktopSize={desktopSize}
      tabletSize={tabletSize}
      {...rest}
    />
  )
}

export default Component
